<div class="chatbot-root" [class.chatbot-root-dashboard]="dashboardWidget">
  <div *ngIf="showGuidebook" class="guidebook-overlay">
    <div class="guidebook-content">
      <div class="guidebook-header">
        <h4>DigiBot Usage Guide</h4>
        <button type="button" (click)="toggleGuidebook()" class="guidebook-close">&times;</button>
      </div>
      <div class="guidebook-body">
        <p>Welcome to DigiBot! You can ask about:</p>
        <ul>
          <li *ngFor="let command of guideCommands">{{ command }}</li>
        </ul>
        <p class="guidebook-tip">
          <strong>Tip:</strong> Type your questions naturally, or tap quick-reply buttons when offered.
        </p>
      </div>
    </div>
  </div>

  <div class="chatbot-shell" [class.chatbot-shell-dashboard]="dashboardWidget" *ngIf="open || dashboardWidget">
    <div class="chatbot-shell-main">
      <div class="chatbot-popup" [class.chatbot-popup-dashboard]="dashboardWidget">
        <div class="chatbot-dashboard-header" *ngIf="dashboardWidget">
          <div class="chatbot-dashboard-title-block">
            <div class="chatbot-dashboard-title">
              <i class="fas fa-comments" aria-hidden="true"></i>
              <span>DigiBot</span>
            </div>
            <p class="chatbot-dashboard-subtitle">Ask about company data, meetings, schedules, and more</p>
          </div>
          <div class="chatbot-dashboard-actions">
            <button type="button" class="dashboard-icon-btn" (click)="toggleGuidebook()" title="Usage guide">
              <i class="fas fa-book"></i>
            </button>
            <button type="button" class="dashboard-icon-btn" (click)="increaseFontSize()" title="Increase text size">
              <i class="fas fa-search-plus"></i>
            </button>
            <button type="button" class="dashboard-icon-btn" (click)="decreaseFontSize()" title="Decrease text size">
              <i class="fas fa-search-minus"></i>
            </button>
            <button type="button" class="dashboard-icon-btn dashboard-icon-btn-danger" (click)="clearChat()" title="Clear chat">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>

        <app-chatbot-messages
          [messages]="messages"
          [isLoading]="isLoading"
          [fontSize]="fontSize"
          [dashboardWidget]="dashboardWidget"
          (recommendedAnswerSelected)="onRecommendedAnswerSelected($event)"
          (followUpQuestionSelected)="onFollowUpQuestionSelected($event)"
          (extractInputSelected)="onExtractInputSelected($event.request, $event.displayLabel)">
        </app-chatbot-messages>

        <div class="chatbot-input" [class.chatbot-input-dashboard]="dashboardWidget">
          <input [(ngModel)]="newMessage" (keydown.enter)="send()" placeholder="Ask something..."
            [disabled]="isLoading" [style.font-size.px]="fontSize" />
          <button type="button" class="chatbot-send-btn" (click)="send()" [disabled]="isLoading || !newMessage.trim()">
            {{ isLoading ? 'Sending...' : 'Send' }}
          </button>
        </div>
      </div>
    </div>

    <div class="chatbot-shell-sidebar" *ngIf="!dashboardWidget">
      <div class="chatbot-controls">
        <div class="font-controls">
          <button type="button" class="control-btn guide-btn" (click)="toggleGuidebook()" title="Usage Guide">
            <i class="fas fa-book"></i>
            <span class="btn-label">Guidebook</span>
          </button>
          <button type="button" class="control-btn toggle-btn" (click)="increaseFontSize()" title="Increase Font Size">
            <i class="fas fa-search-plus"></i>
            <span class="btn-label">Zoom In</span>
          </button>
          <button type="button" class="control-btn toggle-btn" (click)="decreaseFontSize()" title="Decrease Font Size">
            <i class="fas fa-search-minus"></i>
            <span class="btn-label">Zoom Out</span>
          </button>
          <button type="button" class="control-btn clear-btn" (click)="clearChat()" title="Clear Chat">
            <i class="fas fa-trash-alt"></i>
            <span class="btn-label">Reset</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
